import classnames from "classnames";
import SpinnerChase from './SpinnerChase';

type TCardPreloaderProps = {
  className?: string;
}

const CardPreloader = (props: TCardPreloaderProps) => {

  return <div className={classnames('card-preloader', props.className)}>
    <SpinnerChase className="sm" />
  </div>;
}

export default CardPreloader;